import { render } from "./ConfigMasterTutorial.vue?vue&type=template&id=05234406"
import script from "./ConfigMasterTutorial.vue?vue&type=script&lang=js"
export * from "./ConfigMasterTutorial.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__